import React,{useState} from "react";
import circle from './images/dashboard/circle.svg'
import './App.css'


const Dashboard=()=>{

    let [time,reTime]=useState("");
    let [date,reDate]=useState("");

  

    setTimeout(function(){
        let dt=new Date();
        reTime(dt.toLocaleTimeString())
        reDate(`${dt.getDate()}-${dt.getMonth()+1}-${dt.getFullYear()}`)
    },1000);
   
    return (
        <>
        <div className="content-wrapper p-4">
          <div className="page-header">
            <h3 className="page-title">
              <span className="page-title-icon bg-gradient-primary text-white me-2">
                <i className="mdi mdi-home"></i>
              </span> Dashboard
            </h3>
            <nav aria-label="breadcrumb">
              <ul className="breadcrumb">
                <li className="breadcrumb-item active" aria-current="page">
                  <span></span>Overview <i className="mdi mdi-alert-circle-outline icon-sm text-primary align-middle"></i>
                </li>
              </ul>
            </nav>
          </div>
        <div className="card mb-3">
            <div className="card-header text-center pt-3">
                <div className="row">
                    <div className="col-md-6">
                    <h4 className="text-primary d-flex align-items-center"> <i  className="mdi mdi-chip icon-md"/> Institutation Name</h4>
                    </div>
                    <div className="col-md-3">
                    <h4 className="text-success d-flex align-items-center"><i className="mdi mdi-calendar icon-md"/> {date} </h4> 
                    </div>
                    <div className="col-md-3">
                    <h4 className="text-info d-flex align-items-center"><i className="mdi mdi-clock icon-md"/> {time}</h4> 
                    </div>
                </div>
              
                
            </div>
        </div>

            <div className="row">
                <div className="col-md-4 stretch-card grid-margin">
                    <div className="card bg-gradient-dark card-img-holder text-white">
                        <div className="card-body">    
                            <img src={circle}  className="card-img-absolute" alt="" />
                            <h2 className="font-weight-bold mb-3">
                                Generation
                            </h2>
                            <h1 className="mb-4">5685.00 KG</h1>
                            <h6 className="card-text">Increase by 10%</h6>
                        </div>
                    </div>
                </div>
                <div className="col-md-4 stretch-card grid-margin">
                    <div className="card bg-gradient-dark card-img-holder text-white">
                        <div className="card-body">    
                            <img src={circle}  className="card-img-absolute" alt="" />
                            <h2 className="font-weight-bold mb-3">
                                Collection
                            </h2>
                            <h1 className="mb-4">4781.00 KG</h1>
                            <h6 className="card-text">Increase by 10%</h6>
                        </div>
                    </div>
                </div>
                <div className="col-md-4 stretch-card grid-margin">
                    <div className="card bg-gradient-dark card-img-holder text-white">
                        <div className="card-body">    
                            <img src={circle}  className="card-img-absolute" alt="" />
                            <h2 className="font-weight-bold mb-3">
                                Processed 
                            </h2>
                            <h1 className="mb-4">3982.560 KG</h1>
                            <h6 className="card-text">Increase by 10%</h6>
                        </div>
                    </div>
                </div>
            </div>


          <div className="row_container">
        
                {/* start item */}
                <div className="card  bg-gradient-warning card-img-holder text-white">
                            <div className="card-body p-4 text-dark">    
                                <img src={circle}  className="card-img-absolute" alt="" />
                                <h3 className="font-weight-bold mb-2">
                                    Label 1
                                </h3>
                                <h3 className="mb-2">5685.00 KG</h3>
                                <h4 className="card-text">5226 Bages</h4>
                            </div>
                </div>
                {/* End item */}

                  {/* start item */}
                  <div className="card  bg-gradient-danger card-img-holder text-white">
                            <div className="card-body p-4 text-dark">    
                                <img src={circle}  className="card-img-absolute" alt="" />
                                <h3 className="font-weight-bold mb-2">
                                Label 2
                                </h3>
                                <h3 className="mb-2">5685.00 KG</h3>
                                <h4 className="card-text">5226 Bages</h4>
                            </div>
                </div>
                {/* End item */}

                 {/* start item */}
                 <div className="card  bg-gradient-light border border-secondary card-img-holder text-white">
                            <div className="card-body p-4 text-dark">    
                                <img src={circle}  className="card-img-absolute" alt="" />
                                <h3 className="font-weight-bold mb-2">
                                Label 3
                                </h3>
                                <h3 className="mb-2">5685.00 KG</h3>
                                <h4 className="card-text">5226 Bages</h4>
                            </div>
                </div>
                {/* End item */}

                  {/* start item */}
                  <div className="card  bg-gradient-primary card-img-holder text-white">
                            <div className="card-body p-4 text-dark">    
                                <img src={circle}  className="card-img-absolute" alt="" />
                                <h3 className="font-weight-bold mb-2">
                                Label 4
                                </h3>
                                <h3 className="mb-2">5685.00 KG</h3>
                                <h4 className="card-text">5226 Bages</h4>
                            </div>
                </div>
                {/* End item */}

                  {/* start item */}
                  <div className="card  bg-info card-img-holder text-white">
                            <div className="card-body p-4 text-dark">    
                                <img src={circle}  className="card-img-absolute" alt="" />
                                <h3 className="font-weight-bold mb-2">
                                Label 5
                                </h3>
                                <h3 className="mb-2">5685.00 KG</h3>
                                <h4 className="card-text">5226 Bages</h4>
                            </div>
                </div>
                {/* End item */}

                
          </div>

{/* Start Row */}

<div className="row mt-5">
                <div className="col-md-3 stretch-card grid-margin">
                    <div className="card bg-primary card-img-holder text-white">
                        <div className="card-body p-4">    
                            <img src={circle}  className="card-img-absolute" alt="" />
                            <h4 className="font-weight-bold mb-3">
                                HCF VISITED
                            </h4>
                            <h3 className="mb-2">911</h3>
                        </div>
                    </div>
                </div>

                <div className="col-md-3 stretch-card grid-margin">
                    <div className="card bg-dark card-img-holder text-white">
                        <div className="card-body p-4">    
                            <img src={circle}  className="card-img-absolute" alt="" />
                            <h4 className="font-weight-bold mb-3">
                                HCF NOT VISITED
                            </h4>
                            <h3 className="mb-2">911</h3>
                        </div>
                    </div>
                </div>


                <div className="col-md-3 stretch-card grid-margin">
                    <div className="card bg-warning card-img-holder text-white">
                        <div className="card-body p-4">    
                            <img src={circle}  className="card-img-absolute" alt="" />
                            <h4 className="font-weight-bold mb-3">
                              TOTAL VEHICLES
                            </h4>
                            <h3 className="mb-2">911</h3>
                        </div>
                    </div>
                </div>

                <div className="col-md-3 stretch-card grid-margin">
                    <div className="card bg-success card-img-holder text-white">
                        <div className="card-body p-4">    
                            <img src={circle}  className="card-img-absolute" alt="" />
                            <h4 className="font-weight-bold mb-3">
                            ACTIVE VEHICLES
                            </h4>
                            <h3 className="mb-2">911</h3>
                        </div>
                    </div>
                </div>

              
               
            </div>

{/* End Row */}


          </div>
        </>
    )
};

export default  Dashboard;